export default "__VITE_ASSET__E4tH5LgJ__"